<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">停賣列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="form-group text-left">
              <router-link :to="{path: '/chooseDiscount'}">
                <div class="btn btn-default btn-table-title">新增折扣活動</div>
              </router-link>
            </div>
            <br>
            <!--
            <div class="form-group" v-if="getRoleType === 99">
              <select class="form-control h-38" v-model="ownerTypeSelect" @change="getAttendDiscount">
                <option v-for="owner in ownerType" :value="owner.value">
                  {{owner.label}}
                </option>
              </select>
            </div>
            -->
            <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo' && ownerTypeSelect !== 1 && getRoleType !== 10" >
              <!-- <select class="form-control h-38" v-model="brandSelect">
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select> -->
                <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="== 品牌 =="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                    @input="getAttendDiscount"
                  >
                  </multiselect>
            </div>
            <div class="form-group" v-if="brandSelect.value !== 999999 && brandSelect.value !== '999999' && storeBrief.length > 1 && ownerTypeSelect !== 1 && getRoleType !== 30" @change="getAttendDiscount">
              <!-- <select class="form-control h-38" v-model="storeSelect">
                <option v-for="store in storeBrief" :value="store.value">
                  {{store.label}}
                </option>
              </select> -->
              <multiselect
                v-model="storeSelect"
                :options="storeBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 門市 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
                @input="getAttendDiscount"
              >
              </multiselect>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="ruleCodeSelect" @change="getAttendDiscount">
                <option :value="999999">== 折扣規則 ==</option>
                <option
                  v-for="item in ruleCode" 
                  :value="item.rule_code"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="timeMethodSelect" @change="getAttendDiscount">
                <option :value="999999">== 狀態 ==</option>
                <option value="notyet">未開始</option>
                <option value="going">進行中</option>
                <option value="end">已結束</option>
              </select>
            </div>
            <div class="form-group">
              <select class="form-control h-38" v-model="isEnableSelect" @change="getAttendDiscount">
                <option :value="999999">== 啟用狀態 ==</option>
                <option value="1">啟用</option>
                <option value="0">未啟用</option>
              </select>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;" @click="checkSort('id')">折扣活動 (ID)
                      <span v-if="sortMethod === 'id'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;">折扣規則 (代碼)</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>-->
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;">狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;">啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;">擁有者</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" style="vertical-align: middle;" @click="checkSort('start_date')">活動<br>開始
                      <span v-if="sortMethod === 'start_date'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" @click="checkSort('end_date')">活動<br>結束
                      <span v-if="sortMethod === 'end_date'">
                        <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                        <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                      </span>
                      <span v-else>
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                    </th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">你訂<br>平台</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">街口<br>平台</th>
                    <th style="vertical-align: middle;">參與<br>店家</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="(discount, index) in discountList">
                      <td class="sorting_1">{{index + 1}}</td>
                      <td>
                        <router-link v-if="canEdit(discount)" :to="'/discountInfo/' + discount.activity_id">
                          {{discount.name}} ({{discount.activity_id}})
                        </router-link>
                        <div v-else>{{discount.name}} ({{discount.activity_id}})</div>
                      </td>
                      <td>{{discount.rule_name}} ({{discount.rule_code}})</td>
                      <!--<td>{{discount.description}}</td>-->
                      <!--<td>{{discount.sort}}</td>-->
                      <td>
                        <label class="label label-default" v-if="discount.time_method === 'notyet'">未開始</label>
                        <label class="label label-success" v-else-if="discount.time_method === 'going'">進行中</label>
                        <label class="label label-danger" v-else-if="discount.time_method === 'end'">已結束</label>
                      </td>
                      <td>
                        <label class="label label-success" v-if="discount.is_enable === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                      <td>
                        <span v-if="discount.owner_type === 1">平台</span>
                        <span v-if="discount.owner_type === 2">{{discount.owner_brand_name}} ({{discount.owner_id}})</span>
                        <span v-if="discount.owner_type === 3">{{discount.owner_brand_name}} - {{discount.owner_store_name}} ({{discount.owner_id}})</span>
                      </td>
                      <td>{{discount.start_date}}</td>
                      <td>{{discount.end_date}}</td>
                      <td>
                        <label class="label label-success" v-if="discount.is_platform_visible === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                      <td>
                        <label class="label label-success" v-if="discount.dedicated_visible_setting[0] === 1">啟用</label>
                        <label class="label label-danger" v-else>未啟用</label>
                      </td>
                      <td>
                        <router-link v-if="canEdit(discount)" :to="'/discountStore/' + discount.activity_id">
                          <button class="btn btn-primary"><i class="fa fa-home"></i></button>
                        </router-link>
                      </td>
                      <td>
                        <router-link v-if="canEdit(discount)" :to="'/upDiscount/' + discount.activity_id">
                          <button class="btn btn-primary"><i class="fa fa-pencil"></i></button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="storesModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">"{{current.name}}"使用門市</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 p-x-0">
                <label class="label label-primary" style="margin-right: 5px" v-for="store in current.store_list">{{store.name}}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 999999,
        label: '== 門市 =='
      },
      ruleCodeSelect: 999999,
      timeMethodSelect: 999999,
      isEnableSelect: 999999,
      ownerTypeSelect: 999999,
      ownerType: [
        {label: '== 擁有者 ==', value: 999999},
        {label: '品牌', value: 2},
        {label: '門市', value: 3},
        {label: '平台', value: 1}
      ],
      discountList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      preSortMethod: [],
      sortToggle: false,
      sortMethod: '',
      ruleCode: [
        {
          name: '買X送一依金額個位數取固定折抵規則',
          rule_code: 'SD00001'
        },
        {
          name: '買指定商品買X份可折Y元',
          rule_code: 'SD00002'
        },
        {
          name: '買X送Y依消費商品最低價折抵規則',
          rule_code: 'SD00003'
        },
        {
          name: '全品項折扣規則',
          rule_code: 'SD00004'
        },
        {
          name: '購買X數量滿額可折Y元折抵規則',
          rule_code: 'SD00005'
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    canEdit (discount) {
      // 符合 ECMS 可編輯活動
      const list = this.ruleCode.map(item => item.rule_code)
      return list.includes(discount.rule_code)
    },
    getStoreInfo (storeID) {
      const self = this
      const url = '/store/' + storeID + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.brandSelect.value = Number(response.data.info.brand_id)
          self.brandSelect.label = response.data.info.brand_name
        }
      })
    },
    checkSort (method) {
      this.sortMethod = method
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle
        else {
          this.tableIndex = 1
          this.sortToggle = false
        }
        this.preSortMethod.splice(0, 1)
      } else this.sortToggle = false
      this.preSortMethod.push(method)
      this.getAttendDiscount()
    },
    getBrandBrief () {
      const self = this
      this.brandBrief = [{label: '== 品牌 ==', value: 999999}]
      const url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          let bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            if (i === 0 && self.getRoleType === 10) self.brandSelect = obj
            if (self.$route.query.brand) {
              const brand = Number(self.$route.query.brand)
              if (brand === obj.value) {
                self.brandSelect = obj
                self.getAttendDiscount()
              }
            }
            self.brandBrief.push(obj)
          }
        }
      })
    },
    getStoreBrief (brandId) {
      const self = this
      const url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          let sList = response.data.list
          self.storeBrief = [{label: '== 門市 ==', value: 999999}]
          self.storeSelect = {
            value: 999999,
            label: '== 門市 =='
          }
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            /*
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj.value
            } else if (i === 0) self.storeSelect = 999999
            */
            if (self.$route.query.store) {
              const store = Number(self.$route.query.store)
              if (store === obj.value) {
                self.storeSelect = obj
                self.getAttendDiscount()
              }
            }
            // } else {

            // }
          }
          if (!sList.length) {
            self.discountList = []
            self.total = 0
          }
        }
      })
    },
    getAttendDiscount () {
      const self = this
      let url = '/discount/list?&size=' + this.count
      let queryValue = {}
      if (this.storeSelect.value !== 999999 && this.getRoleType !== 30) {
        if (this.$route.query.store !== this.storeSelect.value) {
          queryValue = {...queryValue, ...{store: this.storeSelect.value}}
          this.tableIndex = 1
        } else queryValue = {...queryValue, ...{store: this.storeSelect.value}}
        url = url + '&owner_id=' + this.storeSelect.value
        url = url + '&owner_type=' + 3
      } else if (this.brandSelect.value !== 999999 && this.getRoleType !== 10) {
        if (this.$route.query.brand !== this.brandSelect.value) {
          this.tableIndex = 1
          queryValue = {...queryValue, ...{brand: this.brandSelect.value, page: 1}}
        } else queryValue = {...queryValue, ...{brand: this.brandSelect.value}}
        url = url + '&owner_id=' + this.brandSelect.value
        url = url + '&owner_type=' + 2
      }
      if (this.ruleCodeSelect !== 999999) {
        if (this.$route.query.rule_code !== this.ruleCodeSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{rule_code: this.ruleCodeSelect, page: 1}}
        url = url + '&rule_code=' + this.ruleCodeSelect
      }
      if (this.timeMethodSelect !== 999999) {
        if (this.$route.query.time_method !== this.timeMethodSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{time_method: this.timeMethodSelect, page: 1}}
        url = url + '&time_method=' + this.timeMethodSelect
      }
      if (this.isEnableSelect !== 999999) {
        if (this.$route.query.is_enable !== this.isEnableSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{is_enable: this.isEnableSelect, page: 1}}
        url = url + '&is_enable=' + this.isEnableSelect
      }
      if (this.tableIndex) {
        queryValue = {...queryValue, ...{page: this.tableIndex}}
        url = url + '&page=' + this.tableIndex
      }
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' '
        if (this.sortToggle) {
          url = url + 'ASC'
          queryValue = {...queryValue, ...{list_sort: this.sortMethod, sortToggle: 1}}
        } else {
          queryValue = {...queryValue, ...{list_sort: this.sortMethod, sortToggle: 0}}
          url = url + 'DESC'
        }
      }
      this.$router.push({query: queryValue})
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.discountList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    clickCurrent (menu) {
      this.current = menu
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getAttendDiscount()
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    // if (this.$route.query.brand) {
    //   const brand = this.$route.query.brand
    //   this.brandSelect.value = Number(brand)
    //   // this.brandSelect.label = 'Amy品牌(測)'
    //   this.getAttendDiscount()
    // }
    if (this.getRoleType === 10) {
      this.ownerTypeSelect = 3
    }
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
    if (this.$route.query.store) {
      this.storeSelect.value = this.$route.query.store
      this.getStoreInfo(this.$route.query.store)
    }
    if (this.$route.query.brand) this.brandSelect.value = this.$route.query.brand
    // if (this.$route.query.store) this.storeSelect.value = this.$route.query.store
    if (this.$route.query.rule_code) this.ruleCodeSelect = this.$route.query.rule_code
    if (this.$route.query.time_method) this.timeMethodSelect = this.$route.query.time_method
    if (this.$route.query.is_enable) this.isEnableSelect = this.$route.query.is_enable
    if (this.$route.query.list_sort) this.sortMethod = this.$route.query.list_sort
    if (this.$route.query.page) this.tableIndex = this.$route.query.page
    if (this.$route.query.sortToggle) this.sortToggle = this.$route.query.sortToggle
    if (!this.$route.query.brand && !this.$route.query.store) this.getAttendDiscount()
    // }
  },
  watch: {
    'brandSelect.value' () {
      // this.storeSelect = {
      //   value: 999999,
      //   label: '== 門市 =='
      // }
      this.ownerTypeSelect = 2
      if (this.brandSelect.value !== 999999 && this.brandSelect) this.getStoreBrief(this.brandSelect.value)
    },
    'storeSelect.value' () {
      this.ownerTypeSelect = 3
      this.getAttendDiscount()
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// UpDiscountTable.vue?39113e56